import * as React from "react";
import Modal from "../../misc/components/modal";
import { Form, useFormApi } from "informed";
import { NewDirectoryDialogFormState, DirectoryDialogForm, RenderCheckingIcon } from "./DirectoryDialogForm";
import { QueryOrderDirection } from "../../misc/api/apiTypes";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import { Role } from "webportalclient";
import { MappedServerDirectoryCollapse } from "../DirectoryVisualizer";

interface EditDirectoryDialogProps {
    item: MappedServerDirectoryCollapse;
    roles: Role[];
    checkingDirectory: boolean;
    errorMessage: string;
    handleLinkClick: (directory: NewDirectoryDialogFormState) => void;
    handleCloseDialog: () => void;
}

export const EditDirectoryDialogForm = (props: EditDirectoryDialogProps) => {
    const formApi = useFormApi<NewDirectoryDialogFormState>();

    const handleSubmit = () => {
        formApi.validate();
        const state = formApi.getState();

        if (state.invalid)
            return;

        props.handleLinkClick({ ...state.values, Id: props.item.id });
    }

    return (
        <div className="modal-body">
            <Alert show={props.errorMessage !== undefined} category={AlertCategoryEnum.Danger}>
                {props.errorMessage}
            </Alert>
            <DirectoryDialogForm roles={props.roles} />
            <div className="row">
                <div className="form-group">
                    <div className="col-sm-4">
                        <button className="btn btn-primary" type="submit" onClick={handleSubmit}>Edit Link</button>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    {RenderCheckingIcon(props.checkingDirectory)}
                </div>
            </div>
        </div>
    );
}

export const EditDirectoryDialog = (props: EditDirectoryDialogProps) => {
    const formValues = {
        Id: props.item.id,
        FriendlyName: props.item.name,
        ServerDirectory: props.item.serverDirectory,
        UserRoles: props.item.userRoles.map(ur => props.roles.find(r => r.id === ur))
    }

    return (
        <Modal header="Edit Directory" show={true} closeModalHandler={props.handleCloseDialog}>
            <Form<NewDirectoryDialogFormState> initialValues={formValues}>
                <EditDirectoryDialogForm {...props} />
            </Form>
        </Modal>
    );
}
